<div class="fn-status-modal">
  <div class="fn-status-modal__header">
    <div class="fn-status-modal__title">
      <div>Editar estado de pago</div>
    </div>
    <img
      src="../../../../../../assets/new-styles/icons/buttons/close-icon.svg"
      mat-dialog-close
      class="fn-status-modal__header__icon"
    />
  </div>
  <form [formGroup]="statusForm">
    <!-- <select
      class="form-control form-select shadow-none"
      formControlName="status"
      name=""
      id=""
    >
      <label for="">Estado</label>
      <option *ngFor="let status of this.statusList" [value]="status.key">
        {{ status.value }}
      </option>
    </select> -->
    <mat-checkbox formControlName="status">{{ "IP.SETTLEMENTS.SALE-PAYMENT.IS_PAID" | translate }}</mat-checkbox>
    <app-ip-date-input 
            [control]="paidDate" 
            [label]="'IP.SETTLEMENTS.SALE-PAYMENT.DATE_PAYMENT' | translate"
            inputId="paymentDate"></app-ip-date-input>
    <app-ip-text-area-input
          [control]="paidDescription"
          inputId="paymentDescription"
          [label]="'IP.SETTLEMENTS.SALE-PAYMENT.PAYMENT_DESCRIPTION' | translate"
        ></app-ip-text-area-input>
    <div class="fn-status-modal__btn">
      <button
        class="fn-status-modal__btn-agree"
        (click)="applyFilters()"
        [disabled]="!(statusForm.touched && (status.value === false || (status.value === true && paidDate.value !== '')))"
      >
        Guardar
      </button>
      <button class="fn-status-modal__btn-cancel" (click)="onClose()">
        Cancelar
      </button>
    </div>
  </form>
</div>
